/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout"; 
import DashboardPage from "./pages/Dashboard/Dashboard";
import StoresPage from "./pages/Stores/Stores";
import PaymentsPage from "./pages/Payments/Payments";
import NotificationsPage from "./pages/Notifications/Notifications";
import ShippingPage from "./pages/Shipping/Shipping";
import PlansPage from "./pages/Plans/Plans";
import Employees from "./pages/Employees/Employees";
import Revenues from "./pages/Reports/Revenues";
import PlansReport from "./pages/Reports/PlansReport";
import Growth from "./pages/Reports/Growth";
import PaymentsReports from "./pages/Reports/PaymentsReports";
import SearchResults from "./pages/Search/SearchResults";

import { SearchProvider } from "./context/SearchContext";

export default function AdminApp() {
  return (
    <SearchProvider>
      <Routes>
        <Route path="" element={<Navigate to="dashboard" replace />} />

        <Route
          path="dashboard"
          element={
            <AdminLayout>
              <DashboardPage />
            </AdminLayout>
          }
        />

        <Route
          path="stores"
          element={
            <AdminLayout>
              <StoresPage />
            </AdminLayout>
          }
        />

        <Route
          path="payments"
          element={
            <AdminLayout>
              <PaymentsPage />
            </AdminLayout>
          }
        />

        <Route
          path="notifications"
          element={
            <AdminLayout>
              <NotificationsPage />
            </AdminLayout>
          }
        />

        <Route
          path="shipping"
          element={
            <AdminLayout>
              <ShippingPage />
            </AdminLayout>
          }
        />

        <Route
          path="employees"
          element={
            <AdminLayout>
              <Employees />
            </AdminLayout>
          }
        />

        <Route
          path="plans"
          element={
            <AdminLayout>
              <PlansPage />
            </AdminLayout>
          }
        />

        <Route
          path="revenues"
          element={
            <AdminLayout>
              <Revenues />
            </AdminLayout>
          }
        />

        <Route
          path="plansReport"
          element={
            <AdminLayout>
              <PlansReport />
            </AdminLayout>
          }
        />

        <Route
          path="growth"
          element={
            <AdminLayout>
              <Growth />
            </AdminLayout>
          }
        />

        <Route
          path="paymentsReports"
          element={
            <AdminLayout>
              <PaymentsReports />
            </AdminLayout>
          }
        />

        <Route
          path="search"
          element={
            <AdminLayout>
              <SearchResults />
            </AdminLayout>
          }
        />
      </Routes>
    </SearchProvider>
  );
}
